import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import profileImg from "../../../img/SA.png";
import "./About.css";
import AboutInfo from "./AboutInfo";

const About = () => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [imgError, setImgError] = useState(false);

  return (
    <section id="about">
      <Container>
        <div className="about-heading">
          <p className="section-kicker">
            <span /> A little context
          </p>
          <h1>
            About <em>me.</em>
          </h1>
          <p className="section-lead">The person behind the pixels, processes, and products.</p>
        </div>
        <Row className="about-layout align-items-center g-5">
          <Col xs={12} md={6} data-aos="fade-right" data-aos-easing="linear" data-aos-duration="1000">
            <div className="profile-frame">
              <span className="profile-label">Profile</span>
              <div className="profile-img-wrap">
                {!imgLoaded && !imgError && <span className="profile-img-loader" aria-hidden="true" />}
                {!imgError ? (
                  <img
                    src={profileImg}
                    className={`img-border${imgLoaded ? " is-loaded" : " is-loading"}`}
                    alt="Shoieb Alam"
                    loading="lazy"
                    decoding="async"
                    onLoad={() => setImgLoaded(true)}
                    onError={() => setImgError(true)}
                  />
                ) : (
                  <span className="profile-img-fallback" role="img" aria-label="Shoieb Alam">
                    SA
                  </span>
                )}
              </div>
              <div className="profile-caption">
                <strong>Shoieb Alam</strong>
                <span>Software Engineer</span>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} data-aos="fade-left" data-aos-easing="linear" data-aos-duration="1000">
            <AboutInfo />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
